import React from "react";
import { useTranslation } from "react-i18next";
import CusButton from "../../../mui/CusButton";
import { useAppSelector } from "../../../../store/index.ts";

const textByType = {
  pause: "Pause the queue",
  clear: "Clear the queue",
  earthquake: "Earthquake",
  fireworks: "Fireworks",
  giveControl: "Full Toy",
  random: "Randomly a level between",
  wave: "Wave",
  twowaves: "Two waves",
  pulse: "Pulse",
};

export default function LovenseTipSpecial({ tip, onTipItem, chooseBtn, onBtnClick }) {
  const balance = useAppSelector((state) => state.user.user.balance);
  const { t } = useTranslation();

  const time = tip.minTime ? `${tip.minTime} ~ ${tip.maxTime}` : tip.time || "";
  const isBtn = chooseBtn === tip.id;
  const token = tip.token || `${tip.tokensBegin} ~ ${tip.tokensEnd}`;
  const minToken = tip.token || tip.tokensBegin;
  const maxToken = tip.token || tip.tokensEnd;

  const sendText = tip.token ? `${t("Send")} ${tip.token} ${t("tk")}` : `${"Send"} ${maxToken}`;

  return (
    <div className="chat__tips__item" onClick={() => onTipItem(tip)}>
      <span className="chat__tips__item__actmty">{time ? `${time} ${t("sec.")}` : time}</span>
      <span className={`chat__tips__item__vibro ${tip.type}`}>{t(textByType[tip.type])}</span>

      <span className="chat__tips__item__tokens">
        {isBtn ? (
          <CusButton
            color="red"
            text={balance < minToken ? "Buy tokens" : sendText}
            onClick={(e) => onBtnClick(e, tip)}
          />
        ) : (
          token
        )}
      </span>
    </div>
  );
}
